import { API_EC } from '@/config/api.config';
import { axiosEc } from '@/config/axios.config';
import type {
    HomeNewsApiResponse,
    HomeNewsItem,
} from '@/types/home/home-news.types';

export const getHomeLatestNews = async (): Promise<HomeNewsItem[]> => {
    const response = await axiosEc.post<HomeNewsApiResponse>(
        API_EC.GET_HOME_LATEST_NEWS,
        {
            RequestId: '',
            Data: {
                TopCount: 3,
            },
        }
    );
    const responseData = response.data;
    if (
        !responseData?.IsSuccess ||
        !Array.isArray(responseData.Data?.NewsList)
    ) {
        return [];
    }

    return responseData.Data.NewsList.map((news) => ({
        id: news.Id,
        title: news.Title || '',
        dateString: news.DateString || '',
        newsMonth: news.NewsMonth,
    }));
};
